export default "__VITE_ASSET__qWfXK0gn__"